/**
 * One second measured in milliseconds. To be used with `new Date().getTime()`
 */
exports.ONE_SECOND = 1000

/**
 * One minute measured in milliseconds. To be used with `new Date().getTime()`
 */
exports.ONE_MINUTE = exports.ONE_SECOND * 60

/**
 * One hour measured in milliseconds. To be used with `new Date().getTime()`
 */
exports.ONE_HOUR = exports.ONE_MINUTE * 60

/**
 * One day measured in milliseconds. To be used with `new Date().getTime()`
 */
exports.ONE_DAY = exports.ONE_HOUR * 24

/**
 * One week measured in milliseconds. To be used with `new Date().getTime()`
 */
exports.ONE_WEEK = exports.ONE_DAY * 7

/**
 * 365.2425 days measured in milliseconds. To be used with `new Date().getTime()`
 *
 * Note: This is the average length of a year, including leap-years and
 * skipped-leap-years.
 */
 exports.ONE_YEARISH = exports.ONE_DAY * 365.2425

/**
 * 30.436875 days measured in milliseconds. To be used with `new Date().getTime()`
 *
 * Note: This is `ONE_YEARISH` divided by 12.
 */
exports.ONE_MONTHISH = exports.ONE_YEARISH / 12

/**
 * Weekday constants example: 'monday'
 */
 exports.SUNDAY = 'sunday'
 exports.MONDAY = 'monday'
 exports.TUESDAY = 'tuesday'
 exports.WEDNESDAY = 'wednesday'
 exports.THURSDAY = 'thursday'
 exports.FRIDAY = 'friday'
 exports.SATURDAY = 'saturday'

 /**
 * Weekday labels example: { monday: 'Monday', tuesday: 'Tuesday',}
 */
 exports.DAY_OF_WEEK_LABELS = {
   [exports.SUNDAY]: 'Sunday',
   [exports.MONDAY]: 'Monday',
   [exports.TUESDAY]: 'Tuesday',
   [exports.WEDNESDAY]: 'Wednesday',
   [exports.THURSDAY]: 'Thursday',
   [exports.FRIDAY]: 'Friday',
   [exports.SATURDAY]: 'Saturday',
 }
